<ul class="menu">
  @for (category of categories$ | async; track category) {
    <li>
      <h1>
        <a class="category-link" [routerLink]="categoryLink(category)">{{ category.name }}</a>
      </h1>
      @if (categorySlug == category.slug) {
        <div class="category-container" infiniteScroll [infiniteScrollDistance]="2" (scrolled)="loadNextPage()">
          @if ((exhibits$ | async); as exhibits) {
            @if (!exhibits.length) {
              <div class="account_item_sp">
                <span>In dieser Kategorie gibt es keine Bilder</span>
              </div>
            }
            @for (exhibit of exhibits; track exhibit) {
              <div id="{{ exhibit.slug }}" class="exhibit-container" routerLink="/{{ categorySlug }}/{{ exhibit.slug }}">
                <div class="exhibit_thumb">
                  <img src="{{ exhibit.image.formats.small.url }}" class="img_thumb">
                </div>
                <h3 class="exhibit-title">{{ exhibit.title }}</h3>
              </div>
            }
          }
        </div>
      }
    </li>
  }
</ul>